<div class="container-box">
  <div class="bg">
    @if (type === 'login') {
      <img src="/assets/images/login-register/login_banner.png" alt="" />
    } @else {
      <img src="/assets/images/login-register/register_banner.png" alt="" />
    }
  </div>
  <div class="container">
    <cs-icon-button
      class="close"
      iconType="icon"
      icon="fi-x"
      color="secondary"
      size="12"
      (buttonClick)="close()"
    ></cs-icon-button>
    <div class="tab-box">
      <cs-tab
        class="tab"
        [tabs]="tabs"
        [selectedIndex]="tabIndex"
        padding="lg"
        (tabChange)="onTabChanged($event)"
      ></cs-tab>
    </div>
    <div class="title">Connect your wallet</div>
    <div class="icons">
      <app-third-auth-m8 type="wallet" (clickAuthName)="clickAuthName($event)" [actionFrom]="type"></app-third-auth-m8>
    </div>
    <div class="dividers">
      <div class="divider"></div>
      <div class="text">Or</div>
      <div class="divider"></div>
    </div>
    <form [formGroup]="type === 'login' ? formLogin : formRegister">
      <div class="input-box">
        <cs-input
          [label]="'Enter your email'"
          [placeholder]="'your@email.com'"
          [hasError]="emailHasError"
          errorHint="Invaild email"
          [autocomplete]="type === 'login' ? 'on' : 'off webauthn'"
          formControlName="email"
          prefixIconName="fi-user-filled"
        />
      </div>

      <div class="input-box">
        <cs-input
          [label]="'Enter your password'"
          [placeholder]="''"
          [hasError]="serverErrorText !== ''"
          [autocomplete]="type === 'login' ? 'on' : 'off webauthn'"
          formControlName="password"
          [type]="passwordType"
          prefixIconName="fi-key-filled"
          marginBottom="5px"
          [suffixIconName]="passwordType === 'password' ? 'fi-eye-off' : 'fi-eye'"
          (suffixIconClick)="onPasswordClick()"
        />
        @if (serverErrorText) {
          <p class="server-error">{{ serverErrorText }}</p>
        }
      </div>
      <div class="error-box">
        @if (type === 'login') {
          <div class="forgot" (click)="onForgotClick()">
            <p>Forgot Password?</p>
          </div>
        } @else {
          @if (isRegisterDirty && !formRegister.controls['password'].valid) {
            <ul class="rules">
              <li [class.valid]="!registerPwdErrors.range">
                <i [class]="!registerPwdErrors.range ? 'fi-check' : 'fi-x'"></i>
                <span> Between 8-20 characters </span>
              </li>

              <li [class.valid]="!registerPwdErrors.capital">
                <i [class]="!registerPwdErrors.capital ? 'fi-check' : 'fi-x'"></i>
                <span> 1 capital letter </span>
              </li>
              <li [class.valid]="!registerPwdErrors.number">
                <i [class]="!registerPwdErrors.number ? 'fi-check' : 'fi-x'"></i>
                <span> 1 number </span>
              </li>
            </ul>
          }
        }
      </div>

      <cs-button
        class="submit"
        size="large"
        [label]="type === 'login' ? 'Log In' : 'Sign Up'"
        [disabled]="submitDisabled"
        [loading]="loading"
        (buttonClick)="type === 'login' ? handleLogin() : handleSignUp()"
      ></cs-button>
    </form>
    @if (type === 'login') {
      <p class="warn-text">
        <span (click)="onTabChanged(0)">
          <span>Haven’t created your account yet? </span>
          <span class="link">Sign up</span>
        </span>
      </p>
    } @else {
      <p class="warn-text">
        <span (click)="onTabChanged(1)">
          <span>Do you already have an account? </span>
          <span class="link">Log in</span>
        </span>
      </p>
    }
    <div class="dividers">
      <div class="divider"></div>
      <div class="text">Or</div>
      <div class="divider"></div>
    </div>
    <div class="title">Connect using</div>
    <div class="icons">
      <app-third-auth-m8 [actionFrom]="type"></app-third-auth-m8>
    </div>
  </div>
</div>
